'use client';
import React, { useCallback, useEffect } from 'react';
import {
  Drawer,
  CardHeader,
  CardContent,
  ThemeProvider,
  IconButton
} from '@mui/material';
import { useUser } from '@/utils/supabase/useUser';
import NewslettersForm from '@/components/Newsletters/NewslettersForm';
import theme from '@/app/(signup)/theme';
import { addHours, isAfter, parseISO } from 'date-fns';
import { usePathname } from 'next/navigation';
import { usePopups, PopupTypes } from '@/providers/popups';
import CloseIcon from '@mui/icons-material/Close';

const SubscribeDrawer = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { newsletters, contact } = useUser();
  const pathname = usePathname();
  const { openPopup } = usePopups();

  const evaluteShouldOpen = useCallback(() => {
    const closedAt = localStorage.getItem('subscribeDrawerClosedAt');
    let dueToOpen = false;

    if (!closedAt) {
      dueToOpen = true;
    } else {
      const now = new Date();
      const closedAtDate = parseISO(closedAt);
      const blockUntil = addHours(closedAtDate, 72);
      dueToOpen = isAfter(now, blockUntil);
    }

    const isArticleOrHome =
      pathname === '/' || (pathname && pathname.includes('/articles'));

    const shouldOpen = dueToOpen && isArticleOrHome && !contact;

    if (shouldOpen) {
      openPopup(PopupTypes.NewsletterSubscription);
    }
  }, [pathname, contact, openPopup]);

  useEffect(() => {
    setTimeout(() => {
      evaluteShouldOpen();
    }, 10000);
  }, [evaluteShouldOpen]);

  const handleClose = () => {
    localStorage.setItem('subscribeDrawerClosedAt', new Date().toISOString());
    onClose();
  };

  return (
    <ThemeProvider theme={theme}>
      <Drawer anchor='bottom' open={open} onClose={handleClose}>
        <CardHeader
          title='Subscribe to our Newsletters'
          titleTypographyProps={{ variant: 'h1', align: 'center' }}
          action={
            <IconButton
              aria-label='close'
              onClick={handleClose}
              sx={{
                position: { xs: 'static', sm: 'absolute' },
                right: { sm: 8 },
                top: { sm: 8 }
              }}
            >
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent sx={{ pt: 0 }}>
          <NewslettersForm
            newsletters={newsletters || []}
            newsletterStackVariant='small'
          />
        </CardContent>
      </Drawer>
    </ThemeProvider>
  );
};

export default SubscribeDrawer;
